import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { DashboardFormsDetailComponent } from './dashboard-forms-detail/dashboard-forms-detail.component';
import { DashboardFormsListComponent } from './dashboard-forms-list/dashboard-forms-list.component';
import { DashboardFormsComponent } from './dashboard-forms.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.REPORTS.TITLES.FORMS' }, ɵ1 = { title: 'CORE.SERVICES.NAVIGATION.REPORTS.TITLES.FORMS' }, ɵ2 = { title: 'CORE.SERVICES.NAVIGATION.REPORTS.TITLES.FORMS' };
var routes = [
    {
        path: 'relatorios/formularios',
        component: DashboardFormsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0,
        children: [
            {
                path: '',
                component: DashboardFormsListComponent,
                canActivate: [AuthenticatedGuard],
                data: ɵ1,
            },
            {
                path: 'detalhes',
                component: DashboardFormsDetailComponent,
                canActivate: [AuthenticatedGuard],
                data: ɵ2,
            },
        ]
    },
];
var DashboardFormsModule = /** @class */ (function () {
    function DashboardFormsModule() {
    }
    return DashboardFormsModule;
}());
export { DashboardFormsModule };
export { ɵ0, ɵ1, ɵ2 };
